import { Cookies } from 'react-cookie';
import { LOGIN_INFO_COOKIE_NAME, USER_INFO_COOKIE_NAME, IS_COOKIE_HTTPS_ONLY } from '../../config';
import moment from 'moment';
import logger from '../logger';
import { isNativeApp } from '../util/device';

const ONE_HOUR_IN_SECONDS = 3600; // 60 * 60

const getLoginInfo = appCookies => {
  const cookies = appCookies || new Cookies();
  const returningUserCookie = cookies.get(LOGIN_INFO_COOKIE_NAME);
  if (returningUserCookie) {
    return returningUserCookie;
  }

  return null;
};

const isPersistedLogin = () => {
  const returningUserCookie = getLoginInfo();
  return returningUserCookie && returningUserCookie.persisted;
};

const getUserInfo = () => {
  const getUserCookie = new Cookies().get(USER_INFO_COOKIE_NAME);
  if (getUserCookie) {
    return getUserCookie;
  }

  return null;
};

const setLoginInfo = (token, cookies) => {
  const isPersisted = !!(token.expires_in > ONE_HOUR_IN_SECONDS);
  const cookieValue = {
    tokenType: token.token_type,
    authToken: token.access_token,
    id: token.account_id,
    persisted: isPersisted,
  };

  const opts = {
    maxAge: token.expires_in,
    path: '/',
    secure: IS_COOKIE_HTTPS_ONLY,
  };

  if (isNativeApp()) {
    window.setUserAuthorization(
      token.token_type,
      token.access_token,
      token.account_id,
      token.expiration_timestamp,
      isPersisted
    );
  }

  cookies.set(LOGIN_INFO_COOKIE_NAME, cookieValue, opts);
};

const setUserInfo = response => {
  const cookieValue = {
    firstName: response.first_name,
    lastName: response.last_name,
    email: response.email,
    phone: response.phone,
  };

  const opt = {
    expires: moment()
      .add(1, 'years')
      .toDate(),
    path: '/',
    secure: IS_COOKIE_HTTPS_ONLY,
  };

  new Cookies().set(USER_INFO_COOKIE_NAME, cookieValue, opt);
};

const clearUserAuthorization = (retryCount = 0) => {
  if (typeof window !== 'undefined' && window.clearUserAuthorization)
    window.clearUserAuthorization();
  else if (retryCount < 10) setTimeout(clearUserAuthorization, 100, retryCount + 1);
  else
    logger.error(`Couldn't clear user authorization after ${retryCount} tries at 100ms interval`);
};

const clearUserInfo = cookies => {
  cookies.remove(USER_INFO_COOKIE_NAME, { path: '/' });
  cookies.remove(LOGIN_INFO_COOKIE_NAME, { path: '/' });

  if (isNativeApp()) clearUserAuthorization();
};

export { clearUserInfo, getLoginInfo, getUserInfo, setLoginInfo, setUserInfo, isPersistedLogin };
